import React from 'react';

import styles from './CompetitionsPage.module.css';

type TProps = {
  children: React.ReactNode;
};

export const CompetitionsPageLeftSection = ({ children }: TProps) => (
  <div className={styles.CompetitionsPage__LeftSection}>{children}</div>
);
